export const EXCMDEVICETYPE_CREATE_RESET = 'EXCMDEVICETYPE_CREATE_RESET'
export const EXCMDEVICETYPE_CREATE_SET_CREATED = 'EXCMDEVICETYPE_CREATE_SET_CREATED'
export const EXCMDEVICETYPE_CREATE_SET_ERROR = 'EXCMDEVICETYPE_CREATE_SET_ERROR'
export const EXCMDEVICETYPE_CREATE_SET_VIOLATIONS = 'EXCMDEVICETYPE_CREATE_SET_VIOLATIONS'
export const EXCMDEVICETYPE_CREATE_TOGGLE_LOADING = 'EXCMDEVICETYPE_CREATE_TOGGLE_LOADING'
